import script from "./TabsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsView.vue?vue&type=script&setup=true&lang=js"

import "./TabsView.vue?vue&type=style&index=0&id=3b192dba&scoped=true&lang=css"

import exportComponent from "../../frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b192dba"]])

export default __exports__